import s from './style.css';
import cn from 'classnames';

const icons = {
	arrow: () => (
		<path d="M11.4 3.31l7.6 7.63H1.56A1.56 1.56 0 0 0 0 12.5a1.56 1.56 0 0 0 1.56 1.56H19l-7.6 7.63a1.56 1.56 0 0 0 0 2.21 1.55 1.55 0 0 0 2.2 0L25 12.5 13.6 1.1a1.55 1.55 0 0 0-2.2 0 1.56 1.56 0 0 0 0 2.21z" />
	),
	carrot: () => (
		<path d="M22.92 19.79a1.9 1.9 0 0 1-1.46-.62l-9-9-9 9a2 2 0 0 1-2.92 0 2 2 0 0 1 0-2.92L11 5.83a2 2 0 0 1 2.92 0l10.46 10.42a2 2 0 0 1 0 2.92 1.93 1.93 0 0 1-1.46.62z" />
	),
	close: () => (
		<path
			transform="translate(5.000000, 5.000000)"
			d="M9.34233162,7.49932495 L14.6052789,2.23685133 C14.857343,1.9967552 15,1.66386472 15,1.31576843 C15,0.967672143 14.857343,0.634781661 14.6052789,0.394685534 C14.3651612,0.142644118 14.0322408,3.03690676e-16 13.6841131,2.82351657e-16 C13.3359855,2.61012638e-16 13.0030651,0.142644118 12.7629473,0.394685534 L7.5,5.65715915 L2.23705268,0.394685534 C1.99693494,0.142644118 1.66401449,2.10787873e-17 1.31588687,0 C0.967759248,-2.13390192e-17 0.634838801,0.142644118 0.394721062,0.394685534 C0.142656958,0.634781661 4.29421355e-17,0.967672143 0,1.31576843 C-4.26818802e-17,1.66386472 0.142656958,1.9967552 0.394721062,2.23685133 L5.65766838,7.49932495 L0.394721062,12.7617986 C0.142656958,13.0018947 4.29421355e-17,13.3347852 0,13.6828815 C-4.26818802e-17,14.0309777 0.142656958,14.3638682 0.394721062,14.6039644 C0.642125293,14.8436823 0.968727425,14.9845568 1.31288633,15 C1.65876589,14.9843584 1.98718735,14.843619 2.23705268,14.6039644 L7.5,9.34149074 L12.7629473,14.6039644 C13.0030651,14.8560058 13.3359855,14.9986499 13.6841131,14.9986499 C14.0322408,14.9986499 14.3651612,14.8560058 14.6052789,14.6039644 C14.857343,14.3638682 15,14.0309777 15,13.6828815 C15,13.3347852 14.857343,13.0018947 14.6052789,12.7617986 L9.34233162,7.49932495 Z"
		/>
	),
	download: () => (
		<g>
			<path d="M21.88 17.19v4.69H3.12v-4.69a1.56 1.56 0 0 0-1.56-1.57A1.56 1.56 0 0 0 0 17.19V25h25v-7.81a1.56 1.56 0 0 0-1.56-1.57 1.56 1.56 0 0 0-1.56 1.57z" />
			<path d="M14.06 11.72V1.56A1.56 1.56 0 0 0 12.5 0a1.56 1.56 0 0 0-1.56 1.56v10.16H6.25L12.5 18l6.25-6.25z" />
		</g>
	),
	facebook: () => (
		<path d="M14.47 25h-5.3V12.5H6.52V8.19h2.65V5.6c0-3.51 1.5-5.6 5.75-5.6h3.53v4.31h-2.21c-1.65 0-1.76.6-1.76 1.72v2.16h4L18 12.5h-3.53V25z" />
	),
	hamburger: () => (
		<g>
			<path d="M23.37 6.9H1.63A1.07 1.07 0 0 1 .5 5.76a1.07 1.07 0 0 1 1.13-1.13h21.74a1.07 1.07 0 0 1 1.13 1.13 1.07 1.07 0 0 1-1.13 1.14zm0 6.68H1.63A1.07 1.07 0 0 1 .5 12.44a1.07 1.07 0 0 1 1.13-1.13h21.74a1.07 1.07 0 0 1 1.13 1.13 1.07 1.07 0 0 1-1.13 1.14zm0 6.79H1.63a1.14 1.14 0 0 1 0-2.27h21.74a1.14 1.14 0 0 1 0 2.27z" />
		</g>
	),
	linkedin: () => (
		<path d="M.63 8H5.5v17H.63zm2.31-2.11A2.82 2.82 0 0 1 0 3a2.84 2.84 0 0 1 3-3 2.82 2.82 0 0 1 2.91 3 2.83 2.83 0 0 1-3 2.94zM25 25h-5.53v-8.79c0-2.3-.86-3.87-2.76-3.87a2.84 2.84 0 0 0-2.64 2.08 4.29 4.29 0 0 0-.07 1.39V25H8.48s.07-15.57 0-17H14v2.66c.33-1.16 2.07-2.83 4.87-2.83 3.46 0 6.18 2.45 6.18 7.71V25z" />
	),
	mail: () => (
		<path d="M2.4 9A6.63 6.63 0 0 1 .77 7.47 2.92 2.92 0 0 1 0 5.7 2.47 2.47 0 0 1 .58 4a2.08 2.08 0 0 1 1.65-.67h20.54a2.23 2.23 0 0 1 1.57.67A1.91 1.91 0 0 1 25 5.42a3.28 3.28 0 0 1-.68 2A6.51 6.51 0 0 1 22.61 9l-6.52 4.19c-.1.06-.3.19-.6.4l-.75.49-.73.42a4.88 4.88 0 0 1-.8.35 2.6 2.6 0 0 1-.7.11 2.6 2.6 0 0 1-.7-.11 4.88 4.88 0 0 1-.8-.35l-.75-.5-.75-.49-.6-.4-3.65-2.31zm21.2 1.38A7.56 7.56 0 0 0 25 9.22v10.25a1.92 1.92 0 0 1-.66 1.46 2.23 2.23 0 0 1-1.57.6H2.23a2.23 2.23 0 0 1-1.57-.6A1.92 1.92 0 0 1 0 19.47V9.22a7.47 7.47 0 0 0 1.41 1.12q5.06 3.18 6.93 4.45c.53.37 1 .65 1.29.85a8.32 8.32 0 0 0 1.32.62 4.33 4.33 0 0 0 1.54.32 4.33 4.33 0 0 0 1.54-.32 8.32 8.32 0 0 0 1.32-.62c.33-.2.76-.48 1.29-.85Q19 13.2 23.6 10.34z" />
	),
	minus: () => (
		<path d="M22.92 14.58H2.08A2 2 0 0 1 0 12.5a2 2 0 0 1 2.08-2.08h20.84A2 2 0 0 1 25 12.5a2 2 0 0 1-2.08 2.08z" />
	),
	plus: () => (
		<path d="M22.92 10.42h-8.34V2.08A2 2 0 0 0 12.5 0a2 2 0 0 0-2.08 2.08v8.34H2.08A2 2 0 0 0 0 12.5a2 2 0 0 0 2.08 2.08h8.34v8.34A2 2 0 0 0 12.5 25a2 2 0 0 0 2.08-2.08v-8.34h8.34A2 2 0 0 0 25 12.5a2 2 0 0 0-2.08-2.08z" />
	),
	twitter: () => (
		<path d="M22.05 5.17a5.38 5.38 0 0 0 2.26-3 9.88 9.88 0 0 1-3.26 1.31 5 5 0 0 0-3.74-1.7 5.27 5.27 0 0 0-5.13 5.4 5.61 5.61 0 0 0 .13 1.24A14.33 14.33 0 0 1 1.74 2.77a5.67 5.67 0 0 0-.69 2.73A5.48 5.48 0 0 0 3.33 10 4.94 4.94 0 0 1 1 9.32v.07a5.34 5.34 0 0 0 4.12 5.3 4.64 4.64 0 0 1-1.35.19 5.15 5.15 0 0 1-1-.09 5.16 5.16 0 0 0 4.79 3.75 9.89 9.89 0 0 1-6.37 2.32A8.24 8.24 0 0 1 0 20.78a14 14 0 0 0 7.86 2.43c9.44 0 14.59-8.24 14.59-15.39v-.7A10.71 10.71 0 0 0 25 4.32a9.83 9.83 0 0 1-2.95.85z" />
	)
};

const sizes = {
	s: 14,
	m: 25,
	l: 32
};

const Icon = ({ icon = 'arrow', className, size = 's', title, ...rest }) => (
	<svg
		className={cn(s.icon, { [className]: className })}
		width={`${sizes[size]}px`}
		height={`${sizes[size]}px`}
		viewBox={`0 0 25 25`}
		fill={'currentColor'}
		{...rest}
	>
		{title && <title>{title}</title>}
		{icons[icon]()}
	</svg>
);

export default Icon;



// WEBPACK FOOTER //
// ./elements/icon/index.js